import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
	display: flex;
	align-items: center;
    flex-direction: column;

	@media(max-width: 710px){
		padding-top: 0;
		margin-bottom: 200px;
	}

`;

export const Heander = styled.header`
	position: fixed;
    left: 0px;
    top: 0px;
    z-index: 20;
    width: 100%;
    height: 90px;
    background: #043c54;

	position: relative;

	img {
		margin-top: 10px;
		width: 170px;
		object-fit: contain;

		position: absolute;
		left: 50%;
		top: 18%;
		transform: translate(-50%);
	}
`

export const Titulo = styled.h2`
    font-size: 1.8rem;
    margin-top: 90px;
    text-align: center;
    margin-bottom: 30px;
    font-weight: bold;
    color: rgb(51, 51, 51);
    opacity: 0.7;
	font-family: Poppins, sans-serif;


	@media(max-width: 710px){
		margin-top: 80px;
		font-size: 1.6rem;
	}

`;

export const Formulario = styled.form`
    display: flex;
    align-items: center;
    flex-direction: column;
	justify-content: center;
	align-self: center;

	width: 450px;

    span {
		font-size: 1rem;
		color: rgb(51, 51, 51);
		opacity: 0.7;
		text-align: left;
		font-family: Poppins, sans-serif;
    }

	@media(max-width: 710px) { 
		box-sizing: border-box !important;
		
		width: 100%;
		padding: 0 20px;
	}

`;

export const ItemRadio = styled.div`
	margin-bottom: 20px;

	label {
		margin-right: 5px;
	}

	input {
		margin-right: 15px !important;
	}
`;

export const ItemCelular = styled.div`

	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: flex-start;

	span {
		margin-right: 10px;
	}

	#celular{
		width: 200px;
		margin-top: 5px;
		padding: 5px 3px;
		border-radius: 5px;

		font-size: 1.1rem;
		border: 1px solid #333;
		font-family: Poppins, sans-serif;
		color: rgb(97, 97, 97);
	}

`

export const ItemSelect = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	width: 100%;

	span{
		margin-bottom: 0;
	}
` 

export const SelectForm = styled.select`
	margin-top: 5px;
	padding: 5px 3px;
	border-radius: 5px;
	font-size: 1.1rem;
	border: 1px solid #333;
	font-family: Poppins, sans-serif;
	color: rgb(97, 97, 97);
`

export const BtnEnviar = styled.button`
	margin-top: 30px;
	margin-bottom: 50px;
	padding: 15px 30px;
	background: rgb(63, 182, 252);
	color: #fff;
	border-radius: 5px;
	font-weight: bold;
	font-family: Poppins, sans-serif;
	cursor: pointer;
	font-size: 1.2rem;
	border: none;


	transition: 0.5s;

	&:hover {
		filter: brightness(120%);
	}
`

export const ItemCampoMotivo = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;

	span{
		margin-top: 15px;
	}

	input {
		margin-top: 5px;
		padding: 5px 10px;
		border-radius: 5px;
		font-size: 1.1rem;
		border: 1px solid #333;
		font-family: Poppins, sans-serif;
		color: rgb(97, 97, 97);
	}
`

